import { useState } from "react";
import axios from "axios";
import { Loader2, Mail, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { Checkbox } from "@/components/ui/checkbox";
import { API } from "@/App";
import { getContact, saveContact } from "@/lib/waitlist";

export const EmailResults = ({ resultId, consentText }) => {
  const [email, setEmail] = useState(() => getContact().email || "");
  const [firstName, setFirstName] = useState(() => getContact().firstName || "");
  const [consent, setConsent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    saveContact({ email, firstName });
    try {
      await axios.post(`${API}/results/${resultId}/email`, { email, first_name: firstName || null, marketing_consent: consent });
      setSent(true);
      toast.success("Your complete results are on their way to your inbox.");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Please enter a valid email address.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fea-card no-print" id="email-results" data-testid="email-results-card">
      <p className="fea-overline">Email my results</p>
      <h2 className="font-serif text-2xl sm:text-3xl text-[#800534] mt-2">Receive your complete report by email</h2>
      <p className="fea-body mt-3">Your full personalized report will be sent to your inbox. Receiving your results does not subscribe you to marketing emails.</p>
      {sent ? (
        <p className="flex items-center gap-2 mt-6 text-[#800534] font-medium" data-testid="email-sent-confirmation">
          <CheckCircle2 className="h-5 w-5" /> Sent. Please check your inbox (and your promotions folder).
        </p>
      ) : (
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="email-results-form">
          <div className="grid sm:grid-cols-2 gap-4">
            <input className="fea-input" placeholder="First name (optional)" value={firstName} onChange={(e) => setFirstName(e.target.value)} maxLength={60} data-testid="email-first-name-input" />
            <input className="fea-input" type="email" required placeholder="Your email address" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="email-address-input" />
          </div>
          <label className="flex items-start gap-3 cursor-pointer rounded-xl bg-[#FDF2F4] p-4">
            <Checkbox checked={consent} onCheckedChange={(v) => setConsent(v === true)} className="mt-1 border-[#800534] data-[state=checked]:bg-[#800534]" data-testid="marketing-consent-checkbox" />
            <span className="text-[15px] leading-relaxed text-[#6E4450]">{consentText} <em>(Optional)</em></span>
          </label>
          <button type="submit" disabled={busy} className="fea-btn" data-testid="email-results-submit-button">
            {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <Mail className="h-5 w-5" />} Email My Results
          </button>
        </form>
      )}
    </div>
  );
};
